/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ContactDeliveryMethod, ContactListItemDto, ContactSupplierListItemDto } from '@gh/builder-shared-data';

import { omit } from 'lodash';

export type ContactFinderListItem = ContactListItemDto & {
  orderBy?: ContactDeliveryMethod;
  address?: string;
  scheduleBy?: ContactDeliveryMethod;
};
export const getContactFinderListItemId = ({ id }: ContactFinderListItem) => id;

export const contactFinderListFromSupplierListDto = (dto: ContactSupplierListItemDto): ContactFinderListItem => ({
  ...omit(dto, ['contactId']),
  id: dto.contactId,
  orderBy: dto.orderBy,
  name: dto.name,
  email: dto.email,
  address: dto.address,
  scheduleBy: dto.scheduleBy,
  phones: void 0,
  types: void 0,
  active: void 0,
});
